import jetData from "./raw/jet.json";
import jetReverseData from "./raw/jet_r.json";

export const JetColorMap = (type) => {
  if (type === "range") {
    return jetData;
  }
};

export const JetReverseColorMap = (type) => {
  if (type === "range") {
    return jetReverseData;
  }
};
